(() => {
  const reveal = hash => {
    if (!hash || hash.length < 2) return;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (target?.tagName === 'DETAILS') target.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (link) {
      reveal(link.hash);
      const menu = link.closest('.dd-mobile');
      if (menu) menu.open = false;
    }
  });
  window.addEventListener('hashchange', () => reveal(location.hash));
  reveal(location.hash);
  document.querySelectorAll('[data-dd-product]').forEach(root => {
    const select = root.querySelector('[data-dd-variant]');
    const update = () => {
      const option = select?.selectedOptions[0];
      if (!option) return;
      root.querySelector('[data-dd-price]').textContent = option.dataset.price;
      const button = root.querySelector('[data-dd-add]');
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
      const url = new URL(location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    };
    select?.addEventListener('change', update);
    root.querySelectorAll('[data-dd-image]').forEach(button => button.addEventListener('click', () => {
      const image = root.querySelector('#dd-main-image');
      if (!image) return;
      image.src = button.dataset.ddImage;
      image.removeAttribute('srcset');
      image.alt = button.dataset.ddAlt;
      root.querySelectorAll('[data-dd-image]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
  });
  const dialog = document.getElementById('dd-consent');
  if (!dialog) return;
  const status = dialog.querySelector('[data-dd-consent-status]');
  let api;
  const show = () => {
    const consent = api?.currentVisitorConsent?.() || {};
    dialog.querySelectorAll('[data-dd-consent]').forEach(input => { input.checked = consent[input.dataset.ddConsent] === 'yes'; });
    status.textContent = api ? '' : status.dataset.error;
    if (!dialog.open) dialog.showModal();
  };
  document.querySelectorAll('.dd-privacy-open').forEach(button => button.addEventListener('click', show));
  dialog.querySelectorAll('[data-dd-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.querySelectorAll('[data-dd-save]').forEach(button => button.addEventListener('click', () => {
    if (!api) { status.textContent = status.dataset.error; return; }
    const choice = {};
    dialog.querySelectorAll('[data-dd-consent]').forEach(input => { choice[input.dataset.ddConsent] = button.dataset.ddSave === 'selected' ? input.checked : button.dataset.ddSave === 'accept'; });
    api.setTrackingConsent(choice, error => {
      if (error) { status.textContent = status.dataset.error; return; }
      status.textContent = status.dataset.success;
      dialog.close();
    });
  }));
  dialog.querySelector('[data-dd-optout]')?.addEventListener('click', () => {
    if (!api) { status.textContent = status.dataset.error; return; }
    api.setTrackingConsent({sale_of_data:false}, error => { status.textContent = error ? status.dataset.error : status.dataset.success; });
  });
  const ready = () => {
    api = window.Shopify?.customerPrivacy;
    if (api?.shouldShowBanner?.() && Object.entries(api.currentVisitorConsent()).filter(([key]) => key !== 'sale_of_data').some(([,value]) => value === '')) show();
  };
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => { if (!error) ready(); });
})();
